import { useCallback, useMemo, useState } from 'react';

function getStoredWidths(
  storageKey: string,
  defaultWidths: Record<string, number>
) {
  try {
    const stored = localStorage.getItem(storageKey);
    if (!stored) return defaultWidths;
    return { ...defaultWidths, ...JSON.parse(stored) };
  } catch (e) {
    return defaultWidths;
  }
}

export function useResizableColumns(
  storageKey: string,
  defaultWidths: Record<string, number>
) {
  const [widths, setWidths] = useState(() =>
    getStoredWidths(storageKey, defaultWidths)
  );

  const setWidth = useCallback(
    (key: string, width: number) => {
      setWidths((prev) => {
        const next = { ...prev, [key]: width };
        try {
          localStorage.setItem(storageKey, JSON.stringify(next));
        } catch (e) {
          console.error(e);
        }
        return next;
      });
    },
    [storageKey]
  );

  const scrollX = useMemo(
    () => Object.values(widths).reduce((sum, width) => sum + width, 0),
    [widths]
  );

  return { widths, setWidth, scrollX };
}
